import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterCountrie'
})
export class FilterByCountryPipe implements PipeTransform {
    transform(countries: any[], search: string): any[] {
        if (!search) {
            return countries;
        }
        return countries.filter(country => country.name.toLowerCase().includes(search.toLowerCase()));
    }
}
